import React, { Component } from 'react'
import { Card } from 'react-bootstrap'
import Tabs from 'devextreme-react/tabs'
import DataPeserta from './dataPeserta'
import RiwayatTransaksi from './riwayatTransaksi'
import Simulasi from './simulasi'

class DetailData extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedTabIndex: 0,
    }

    this.dataPesertaRef = React.createRef()
    this.riwayatTransaksiRef = React.createRef()
    this.simulasiRef = React.createRef()

    this.TabDataSource = [
      {
        id: 0,
        text: 'Data Peserta',
      },
      {
        id: 1,
        text: 'Riwayat Transaksi',
      },
      {
        id: 2,
        text: 'Simulasi',
      },
    ]
  }

  onTabSelectionChanged = (args) => {
    if (args.name === 'selectedIndex' && args.value !== -1) {
      this.setState({
        selectedTabIndex: args.value,
      })
    }
  }

  retrieveData = (data) => {
    if (data) {
      this.dataPesertaRef.current.retrieveData({
        iuran: data.iuran,
        keluarga: data.keluarga,
        saldo: data.saldo,
      })
      this.riwayatTransaksiRef.current.retrieveData(data.riwayatTransaksi)
      this.simulasiRef.current.retrieveData({
        simulasiBerkala: data.simulasiBerkala,
        simulasiMp: data.simulasiMp,
      })
    }
  }

  render() {
    return (
      <div>
        <Card style={{ height: '1035px' }}>
          <Card.Body
            style={{
              paddingTop: '12px',
              paddingRight: '16px',
              paddingBottom: '12px',
              paddingLeft: '16px',
            }}
          >
            <div className="row">
              <div className="col-md-12">
                <Tabs
                  dataSource={this.TabDataSource}
                  selectedIndex={this.state.selectedTabIndex}
                  onOptionChanged={this.onTabSelectionChanged}
                />
              </div>
            </div>
            <div>
              <div
                id={`tabIndexModalDetil-0`}
                className={
                  (this.state.selectedTabIndex !== 0 ? 'd-none' : '') +
                  ' mt-2 col-md-12'
                }
                style={{ minHeight: 'calc(30vh)' }}
              >
                <DataPeserta
                  store={this.props.store}
                  ref={this.dataPesertaRef}
                />
              </div>
              <div
                id={`tabIndexModalDetil-1`}
                className={
                  (this.state.selectedTabIndex !== 1 ? 'd-none' : '') +
                  ' mt-2 col-md-12'
                }
                style={{ minHeight: 'calc(30vh)' }}
              >
                <RiwayatTransaksi
                  store={this.props.store}
                  ref={this.riwayatTransaksiRef}
                />
              </div>
              <div
                id={`tabIndexModalDetil-2`}
                className={
                  (this.state.selectedTabIndex !== 2 ? 'd-none' : '') +
                  ' mt-2 col-md-12'
                }
                style={{ minHeight: 'calc(30vh)' }}
              >
                <Simulasi store={this.props.store} ref={this.simulasiRef} />
              </div>
            </div>
          </Card.Body>
        </Card>
      </div>
    )
  }
}

export default DetailData
